// 由 tools/pack-fullstack.sh 打包时生成（仓库内为占位 dev）
export const GAME_VERSION = 'b5ae75a+0830';
